<template>
	<div class="summary sticky" :style="'--accent:' + this.accent" v-if="summary_data !=null">
		<p class="heading">
			£<span>{{ summary_data.total_price_formatted }}</span>pp
			<i class="fas fa-chevron-down"></i>
		</p>
		<div class="summary_details">
			<template v-if="this.summary_data != null && (Object.keys(this.summary_data.upgrades).length > 0) || Object.keys(this.summary_data.addons).length > 0">
				<ul class="level_1">
					<li v-if="this.summary_data != null && Object.keys(this.summary_data.upgrades).length > 0">
						Upgrades
						<ul class="level_2">
							<li v-for="item in summary_data.upgrades" v-if="item.option_price > 0">
								{{ item.activity_name }} {{ item.option_name }} <button class="remove"><i class="fas fa-minus-circle" v-on:click="removeActivity(item.activity_id)"></i></button>
							</li>
						</ul>
					</li>
					<li v-if="this.summary_data != null && Object.keys(this.summary_data.addons).length > 0">
						Extras
						<ul class="level_2">
							<li v-for="item in summary_data.addons">
								{{ item.activity_name }} {{ item.option_name }} <button class="remove"><i class="fas fa-minus-circle" v-on:click="removeActivity(item.activity_id)"></i></button>
							</li>
						</ul>
					</li>
				</ul>
			</template>
			<p><small>*subject to availability</small></p>
			<span class="spacer"></span>
			<button type="button" class="button medium solid wide" v-on:click="toggleQuoteForm()">Get Quote</button>
			<p class="build">or</p>
			<a :href="builder_slug" class="button medium solid wide build">Build your own</a>
		</div>
	</div>
	<div class="summary loading sticky" :style="'--accent:' + this.accent" v-else>
		<i class="fas fa-spinner fa-spin"></i>
	</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {

	props: [
		'package_id',
		'accent',
		'builder_slug'
	],

	data: () => {
		return {
			summary_data: null
		}
	},

	computed: {
		package () {
			return this.$store.getters.getItem(this.package_id, 'package');
		},
		all_package () {
			return this.$store.getters.getAllEntries;
		}
	},

	watch: {
		package: function(value) {
			this.getPackageInfo();
		}
	},

	created() {
	},

	mounted() {
		this.getPackageInfo();
	},

	methods: {

		getPackageInfo: function(){
			axios.post('/ajax/getPackageInfo', {
				package_id: parseInt(this.package_id), 
				basket: this.package
			})
			.then(response => {
				this.summary_data = response.data
			})
			.catch(error => {
				console.log(error);
			});
		},

		removeActivity: function(activity_id){
			this.$store.commit({
				type: 'removeActivityFromStore',
				store_type: 'package',
				store_id: parseInt(this.package_id),
				activity_id: parseInt(activity_id),
			});
		},

		toggleQuoteForm: function(){
			this.$root.$refs.quoteform.toggleQuoteForm();
		}

	}
};
</script>